// extracted by mini-css-extract-plugin
module.exports = {"instaLink":"Instagram_instaLink__MLt9j","instaIcon":"Instagram_instaIcon__1pJVM","instaText":"Instagram_instaText__tJ7PD"};